import { useMutation } from "@tanstack/react-query";
import { gql } from "graphql-request";

import { PaymentSignature } from "../types";
import { axiosQuery } from "../utils/axiosHelpers";

const MUTATION = gql`
  mutation PaymentSignature($pageId: ID!) {
    paymentSignature(pageId: $pageId) {
      key
      signature
      tenantId
      token
    }
  }
`;

interface PaymentSignatureResponse {
  paymentSignature: PaymentSignature;
}

export const useCreatePaymentSignature = () =>
  useMutation<PaymentSignature, Error, { pageId: string }>({
    mutationFn: async (variables) => {
      const response = await axiosQuery<PaymentSignatureResponse>(
        "PaymentSignature",
        MUTATION,
        variables,
      );
      return response.paymentSignature;
    },
  });
